import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=f5526988"
import script from "./RecordsTable.vue?vue&type=script&lang=js"
export * from "./RecordsTable.vue?vue&type=script&lang=js"
import style0 from "./RecordsTable.vue?vue&type=style&index=0&id=f5526988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports